
import { httpRequest, defaults } from '@igetcool/base-components';
// import qs from 'qs';
const privew = '/app-api-user-server/white/';

/**
 * 获取验证码
 * @param {query}
 * @param {phone} 手机号
 * @param {countrycode}  手机区号
 */
export const getCodeRequest = (query, type) => {
  if (type) {
    return httpRequest.get(`${privew}sms/voice/v1.json`, {
      ...query,
      smstype: 0
    });
  }
  return httpRequest.get(`${privew}sms/smscode/v1.json`, {
    ...query,
    smstype: 0,
    type: 1
  }, {
    headers: {
      'App-Version': '3.0.0'
    }
  });
};

/**
 * 登录/注册
 * @param {phone} 手机号
 * @param {countrycode} 手机号区号
 * @param {smscode} 验证码
 * @param {putUrl} 投放地址
 * @param {userChannel} 投放渠道
 * @param {shareUserPid}
 * @param {h5Pid}
 */
const operatePrivew = '/growth-server/';

// const defaultApi = `${operatePrivew}user/codeLogin`;
const defaultApi = `${operatePrivew}user/codeLogin/v1`;
const defaultHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded'
};


export const loginRegisterRequest = (params, api = defaultApi, headers = {}, axiosOption = {}) => {
  headers = defaults(headers, defaultHeaders);
  return httpRequest.post(api, params, {
    headers,
    forceAjax: true,
    ...axiosOption
  });
};

export const checkLoginToken = params => {
  return httpRequest.get('/app-api-user-server/white/authToken/checkToken.json', params);
};
